import httpClient from './httpClient';

/**
 * Serviço para consumir os endpoints de tipos de tarefas. Expõe
 * operações de listagem, criação, atualização e remoção de tipos de
 * tarefas. Somente usuários administradores podem modificar dados,
 * enquanto qualquer usuário autenticado pode listar.
 */

/**
 * Lista todos os tipos de tarefas cadastrados.
 *
 * @returns {Promise<Array>} Array de objetos tipoDeTarefa
 */
export async function listarTiposDeTarefa() {
  const resp = await httpClient.get('/api/tipos-tarefa');
  return Array.isArray(resp.data) ? resp.data : [];
}

/**
 * Cria um novo tipo de tarefa. Somente usuários admin devem
 * chamar esta função.
 *
 * @param {object} tipo objeto com os campos { nomeTipo, scoreTipo }
 * @returns {Promise<object>} tipo criado
 */
export async function criarTipoDeTarefa(tipo) {
  const resp = await httpClient.post('/api/tipos-tarefa', tipo);
  return resp.data;
}

/**
 * Atualiza um tipo de tarefa existente. Somente admins podem
 * executar. O payload deve conter os campos a serem atualizados.
 *
 * @param {number|string} id identificador do tipo
 * @param {object} tipo dados a serem atualizados
 * @returns {Promise<object>} tipo atualizado
 */
export async function atualizarTipoDeTarefa(id, tipo) {
  const resp = await httpClient.put(`/api/tipos-tarefa/${id}`, tipo);
  return resp.data;
}

/**
 * Remove um tipo de tarefa existente. Somente admins podem
 * executar.
 *
 * @param {number|string} id identificador do tipo
 */
export async function removerTipoDeTarefa(id) {
  await httpClient.delete(`/api/tipos-tarefa/${id}`);
}
